export default {
    data() {
        return {
            //是否出现加载中符号
            loading: true,
            all: 1, //总页数
            cur: 1, //当前页码
            //选择打印证书按钮
            certificateButton: true,
            //选择多个证书打印数组
            certificateArr: [],
            //已完成的证书
            okCertificate: [],
            orderId: '',
            goodId: '',
            shopId: '',
            isNeedYear: false,
            infoRemind: '请确认信息无误',
            finishedClassNum: 0,
            studyingClassNum: 0,
            certificateFinished: 0,
            // certificateGenerate: 0,
            certificateNot: 0,
            annual: '',
            headImg: require('../../assets/images/avatar.jpg'),
            users: {},
            //全部课程
            classList: [],
            //在读课程
            inschoolclass: [],
            //已完成课程
            accomplishclass: [],
            // 未完成证书
            unfinishedcredential: [],
            // 已完成证书
            accomplishcredential: [],
            // 已生成证书
            certificateList: [],
            inputModel: [],
            message: '',
            // 课程类型筛选
            checked1: false,
            checked2: false,
            // 认定类型筛选
            checked3: false,
            checked4: false,
            // 历史套餐
            checked5: false,
            // 年度筛选
            options: [{
                value: '全部',
                label: '全部'
            }],
            value: '全部',
            cosl: 1, //点击课程导航标记
            cosl0: 1, //点击证书导航标记
            is_project: this.$store.state.store.is_project, //判断导航栏显示
            // 每页显示条数
            pageSize: 5,
            // 当前页
            currentPage: 1,
            // 总页数
            total: 0,
            // 是否显示分页, 在已生成的证书那里是不需要的
            isShowPagination: true,
            orderID: '',
            // 套餐id
            categoryId: '',
            // 套餐名称
            categoryName: '',
            // 套餐年份
            categoryYear: '',
            // 郑州平台旧用户数据
            oldPackage: [],
            // 用户购买的单个
            purchasedList: []
        }
    },
    methods: {

        // 打印证书
        printCertificate(item) {
            let categoryId = item.category_id;
            this.categoryName = item.name;
            let categoryYear = item.year;
            let categoryOrderId = item.category_order_id;

            // 获取当前课程包的开始学习时间和结束学习时间
            this.$post('category_order/get_date', {
                id: categoryOrderId
            }).then(res => {
                let {
                    study_start_time,
                    study_end_time
                } = res.data.result;

                if (this.$store.state.store.id == 107) {
                    // 创建证书
                    this.$post('cers/create', {
                        token: this.$store.state.id,
                        category_ids: JSON.stringify([categoryId]),
                        cer_year: categoryYear,
                        pay_date: study_start_time,
                        end_date: study_end_time
                    }).then(res2 => {

                        // 生成证书后，将当前的课程包的是否已生成证书修改为已生成
                        this.$post('category_order/update', {
                            id: categoryOrderId,
                            is_first: 1
                        });

                        // 跳转到证书页面
                        this.goCertificate(study_start_time, study_end_time, JSON.stringify([
                            categoryId
                        ]), Number.parseFloat(
                            categoryYear));
                    })
                } else {
                    this.$post('cers/makeCert', {
                        category_id: categoryId,
                        category_name: this.categoryName,
                        cer_year: categoryYear,
                        pay_date: study_start_time,
                        end_date: study_end_time,
                        token: this.$store.state.id,
                    }).then(res => {
                        window.open(`${window.location.origin}/${res.data.result.file_path}`)
                    })
                }
            })
        },


        //打印证书按钮
        printButton(item) {
            // console.log(item);
            // this.categoryId = item.category_id;
            // this.categoryName = item.category_name;
            // this.categoryYear = item.category_year;
            // // console.log(item)
            // let arr = []
            // this.certificateArr = item.purchased
            // this.confirmPrint()
            // // console.log(arr)
        },
        //选择多选框改变确认打印按钮
        isPrint: function() {
            if (this.certificateArr.length > 0) {
                document.querySelector('#confirm-print-btn').removeAttribute('disabled');
            } else {
                document.querySelector('#confirm-print-btn').setAttribute('disabled', 'disabled');
            }
        },
        //选择证书打印
        chooseCertificate: function() {
            if (this.certificateButton == true) {
                this.certificateButton = false;
                this.certificateArr = [];
            } else {
                this.certificateButton = true;
                document.querySelector('#confirm-print-btn').setAttribute('disabled', 'disabled');
            }
        },

        //证书详情页面跳转
        goCertificate: function(pay_date, end_date, categoryIds, year) {
            // UIkit.modal(document.querySelector('#modal-personalcenter')).hide()
            // // 修改为当前页跳转
            // this.$router.push({
            //     path: '/studyingcertificate',
            //     query: {
            //         pay_date: pay_date,
            //         end_date: end_date,
            //         goodId: goodId,
            //         year: year
            //     }
            // })
            let address = this.$router.resolve({
                path: '/studyingcertificate',
                query: {
                    pay_date: pay_date,
                    end_date: end_date,
                    categoryIds: categoryIds,
                    year: year,
                    name: this.categoryName
                }
            });
            window.open(address.href, '_blank');
        },
        //高校的证书详情页面跳转
        highSchoolCertificate: function(pay_date, end_date, goodId, year) {
            let address = this.$router.resolve({
                path: '/studyingcertificatehigh',
                query: {
                    pay_date: pay_date,
                    end_date: end_date,
                    goodId: goodId,
                    year: year,

                }
            });
            window.open(address.href, '_blank');
        },
        downloadBook: function(item) {
            let cersId = item.cer_id
            // 获取证书的信息
            this.$post('cers/get', {
                id: cersId
            }).then(res => {
                let {
                    category_ids,
                    cer_year,
                    pay_date,
                    end_date
                } = res.data.result;

                if (this.$store.state.store.id == 107) {
                    // 获取当前证书名称
                    this.$post('product_category/get_categorys', {
                        category_ids: category_ids,
                        offset: 0,
                        length: 999
                    }).then(res2 => {
                        let list = res2.data.result.data;

                        // 目前是一个课程包一个证书，到时候变再改
                        // for (let item of list) {
                        //     this.categoryName.push(item.name);
                        // }
                        this.categoryName = list[0].name

                        // 跳转到证书页面
                        this.goCertificate(pay_date, end_date, category_ids, cer_year);
                    });
                } else {
                    this.printCertificate(item)
                }

            })

            // let ids = []
            // item.purchased.map(item => {
            // 	ids.push(item.purchased_id)
            // })
            // this.categoryName = item.category_name
            // //判断如果是id是5，即高校店铺则要跳转不同页面打印不同的学时证明
            // if (this.$store.state.store.id == "5") {
            // 	this.highSchoolCertificate(item.pay_date, item.end_date, item.cer_year);
            // } else {
            // 	//不是高校店铺的学时证明
            // 	this.goCertificate(item.pay_date, item.end_date, JSON.stringify(ids), item.cer_year)
            // }

        },
        //跳转首页
        goIndex: function() {
            this.$router.push({
                path: '/'
            })
        },
        //跳转课程详情
        classDetails: function(id, is_project, purchased_id, categoryOrderId) {
            let address = this.$router.resolve({
                path: '/classstudy',
                query: {
                    id: id,
                    purchased_id: purchased_id,
                    categoryOrderId: categoryOrderId
                }
            });
            window.open(address.href, "_blank")
            // this.$toClass(id, is_project, purchased_id);
        },
        //获取个人信息
        getusers: function() {
            this.$post('users/profile', {
                token: this.$store.state.id
            }).then(res => {
                this.users = res.data.result;
                this.users.name ? document.querySelector('#name').setAttribute('disabled', 'disabled') :
                    this.users.name;
                this.users.company ? document.querySelector('#company').setAttribute('disabled',
                    'disabled') : this.users.company;
                //   //判断信息是否完成，如若一项不完成都弹出下面的提示
                //   if (this.users.name == null || this.users.company == null || this.users.name == '' || this.users.company == '') {
                //       this.message = '请完善个人信息，如不需要开具学时证明，则可以不填写。';
                //       let model = document.querySelector('#modal-tip-addname');
                //       UIkit.modal(model).show();
                //   }
            })
        },
        //跳转编辑个人信息页面
        editInfo: function() {
            this.$router.push({
                path: '/editinfo'
            })
        },
        //跳转更改密码页面
        changepassword: function() {
            this.$router.push({
                path: '/changepassword'
            })
        },
        updateKeyDown: function() {

        },
        //确认打印证书按钮的判断和给出提示
        confirmPrint: function() {
            // UIkit.modal(document.querySelector('#modal-same-year')).show();
            // UIkit.modal(document.querySelector('#modal-personalcenter')).show();

            console.log(this.certificateArr, '-------------------')
            // // 置空年度
            // this.annual = '';
            // //存储课程自带的年度
            // let cer_years = [];
            // //专业课数组
            // let proClass = [];
            // //选修课数组
            // let avoClass = [];
            // for (let val of this.certificateArr) {
            //     //遍历把数组添加进去专业数组和选修数组
            //     if (val.attr == '专业课') {
            //         proClass.push(val);
            //     }
            //     if (val.attr == '选修课') {
            //         avoClass.push(val);
            //     }
            //     //遍历数组把课程自带年度和预设年度都储存年度数组
            //     if (val.cer_year && val.cer_year != null && val.cer_year != '') {
            //         cer_years.push(Number.parseFloat(val.cer_year.substr(0, 4)));
            //     } else if (val.is_first && val.is_first != null && val.is_first != '') {
            //         cer_years.push(Number.parseFloat(val.is_first));
            //     }
            // }
            
            // console.log('cer_years', cer_years)
            
            // if(cer_years.length > 1) {
            //     this.tipModalOne(cer_years)
            //     if (!this.isSame(cer_years)) {
            //         UIkit.modal(document.querySelector('#modal-same-year')).show();
            //     } else {
            //         this.tipModalOne(cer_years)
            //     }
            // }
            
            // //若专业课和选修课都有，则弹出提示不能同时打印，并终止方法
            // // if (proClass.length > 0 && avoClass.length > 0) {
            // //     UIkit.modal(document.querySelector('#modal-no-attr')).show();
            // //     return;
            // // }
            // //若年度数组长度为零，则说明无自带年度和预设年度，就要出现填写年度的的输入框
            // if (cer_years.length == 0) {
            //     let str = '请填写';
            //     this.isNeedYear = true;
            //     this.users.name == '' ? str += '姓名，' : str;
            //     this.users.idcard == '' ? str += '身份证号，' : str;
            //     this.users.company == '' ? str += '单位名称，' : str;
            //     this.annual == '' || Number.parseFloat(this.annual) < 2018 || this.annual.toString().length > 4 ?
            //         str +=
            //         '申报年度，申报年度格式为：例子：2018，且不能是2018年之前的，' : str;
            //     str = str.substr(0, str.length - 1);
            //     this.infoRemind = str;
            //     UIkit.modal(document.querySelector('#modal-personalcenter')).show();
            // } else if (cer_years.length == 1) {
            //     this.tipModalOne(cer_years);
            // } else if (cer_years.length > 1) {
            //     if (!this.isSame(cer_years)) {
            //         UIkit.modal(document.querySelector('#modal-same-year')).show();
            //     } else {
            //         this.tipModalOne(cer_years)
            //     }
            // }
        },

        //判断一个数组里面的东西是否都是一样的
        isSame: function(arr) {
            for (let val of arr) {
                if (val !== arr[0]) {
                    return false;
                }
            }
            return true;
        },
        //提示模板1
        tipModalOne: function(cer_years) {
            this.isNeedYear = false;
            if (!this.users.name || !this.users.idcard || !this.users.company) {
                let str = '请填写';
                this.isNeedYear = false;
                this.users.name == '' ? str += '姓名，' : str;
                this.users.idcard == '' ? str += '身份证号，' : str;
                this.users.company == '' ? str += '单位名称，' : str;
                this.certificateArr.length > 1 ? str += '本次证明中包含【仅适用于' + cer_years[0] + '】的课程，其余课程无法设置为其他年度，' : str;
                str = str.substr(0, str.length - 1);
                this.infoRemind = str;
            } else {
                this.infoRemind = '请确认信息无误，'
                this.certificateArr.length > 1 ? this.infoRemind += '本次证明中包含【仅适用于' + cer_years[0] +
                    '】的课程，其余课程无法设置为其他年度，' : this.infoRemind;
                this.infoRemind = this.infoRemind.substr(0, this.infoRemind.length - 1);
            }
            UIkit.modal(document.querySelector('#modal-personalcenter')).show();
        },
        //证书保存
        saveCertificate: function() {
            //存储课程自带的年度
            let cer_years = [];
            //用户id
            let owner_id = this.$store.state.userId;
            //订单项id
            let purchased_ids = [];
            //订单项的订单时间数组
            let order_times = [];
            //最小的时间戳
            let small_times = Infinity;
            //最小时间段
            let samll_Dates = '';
            //最大时间戳
            let big_times = -Infinity;
            //最大时间端
            let big_Dates = '';
            for (let val of this.certificateArr) {
                purchased_ids.push(Number.parseFloat(val.purchased_id))
                order_times.push(val.created_at);
                //获得数个订单项里面最小的日期时间
                if (new Date((val.created_at).replace(/-/g, "/")).getTime() < small_times) {
                    small_times = new Date((val.created_at).replace(/-/g, "/")).getTime();
                    samll_Dates = val.created_at;
                }
                //获得数个订单项里面最大的日期时间
                if (new Date((val.updated_at).replace(/-/g, "/")).getTime() > big_times) {
                    big_times = new Date((val.created_at).replace(/-/g, "/")).getTime();
                    big_Dates = val.updated_at;
                }
                if (val.cer_year && val.cer_year != null && val.cer_year != '') {
                    cer_years.push(Number.parseFloat(val.cer_year.substr(0, 4)));
                } else if (val.is_first && val.is_first != null && val.is_first != '') {
                    cer_years.push(Number.parseFloat(val.is_first));
                }

            }
            // console.log('purchased_ids',purchased_ids)
            // console.log('order_times',order_times)
            // console.log('order_times',order_times)
            // console.log('small_times',small_times)
            // console.log('samll_Dates',samll_Dates)
            // console.log('big_times',big_times)
            // console.log('big_Dates',big_Dates)
            // console.log('cer_years',cer_years)
            if (cer_years.length == 0) {
                let index = 0;
                if (this.users.name && this.users.idcard && this.users.company && Number.parseFloat(this.annual) >
                    2017 && this.annual
                    .length == 4) {
                    this.$post('cers/create', {
                        token: this.$store.state.id,
                        // purchased_id: JSON.stringify(purchased_ids),
                        order_id: this.orderID,
                        owner_id: owner_id,
                        cer_year: Number.parseFloat(this.annual),
                        pay_date: samll_Dates,
                        end_date: big_Dates
                    }).then(res => {
                        UIkit.modal(document.querySelector('#modal-personalcenter')).hide();

                        if (this.$store.state.store.id == "5") {
                            this.highSchoolCertificate(samll_Dates, big_Dates, JSON.stringify(
                                purchased_ids), Number.parseFloat(this.annual));
                        } else {
                            //跳转生成证书
                            this.goCertificate(samll_Dates, big_Dates, JSON.stringify(purchased_ids), Number
                                .parseFloat(this.annual));
                        }

                        this.$post('orders/update_first', {
                            token: this.$store.state.id,
                            id: this.orderID,
                            is_first: 1
                        }).then(res => {
                            this.screen1()
                        })

                        //这里生成证书，
                        for (let orderGoodId of purchased_ids) {
                            this.$post('purchased/updateCerYear', {
                                token: this.$store.state.id,
                                is_first: this.annual,
                                id: orderGoodId,
                                cer_year: 1
                            }).then(res => {

                                ++index;
                                if (index == purchased_ids.length) {
                                    setTimeout(() => {
                                        this.certificateList = [];
                                        this.classList = [];
                                        this.certificateArr = [];
                                        this.certificateButton = true;
                                        this.getMyCertificate();
                                        this.alreadyCreated()
                                    }, 1000)
                                }
                            })
                        }
                    })

                } else {
                    let str = '请填写';
                    this.users.name == '' ? str += '姓名，' : str;
                    this.users.idcard == '' ? str += '身份证号，' : str;
                    this.users.company == '' ? str += '单位名称，' : str;
                    this.annual == '' || Number.parseFloat(this.annual) < 2018 ? str +=
                        '申报年度，申报年度格式为：例子：2018，且不能是2018年之前的，' : str;
                    str = str.substr(0, str.length - 1);
                    this.infoRemind = str;
                }
            } else if (cer_years.length >= 1) {
                this.annual = Number.parseFloat(cer_years[0].toString().substr(0, 4));
                let index = 0;
                if (this.users.name && this.users.idcard && this.users.company) {
                    this.$post('cers/create', {
                        token: this.$store.state.id,
                        purchased_id: JSON.stringify(purchased_ids),
                        owner_id: owner_id,
                        cer_year: Number.parseFloat(this.annual),
                        pay_date: samll_Dates,
                        end_date: big_Dates
                    }).then(res => {
                        UIkit.modal(document.querySelector('#modal-personalcenter')).hide();
                        if (this.$store.state.store.id == "5") {
                            this.highSchoolCertificate(samll_Dates, big_Dates, JSON.stringify(
                                purchased_ids), Number.parseFloat(this.annual));
                        } else {
                            //跳转生成证书
                            this.goCertificate(samll_Dates, big_Dates, JSON.stringify(purchased_ids), Number
                                .parseFloat(this.annual));
                        }
                        for (let orderGoodId of purchased_ids) {
                            this.$post('purchased/updateCerYear', {
                                token: this.$store.state.id,
                                is_first: this.annual,
                                id: orderGoodId,
                                cer_year: 1
                            }).then(res => {
                                ++index;
                                if (index == purchased_ids.length) {
                                    setTimeout(() => {
                                        this.certificateList = [];
                                        this.classList = [];
                                        this.certificateArr = [];
                                        this.certificateButton = true;
                                        this.getMyCertificate();
                                        this.alreadyCreated()
                                    }, 1000)
                                }
                            })
                        }
                    })

                } else {
                    let str = '请填写';
                    this.users.name == '' ? str += '姓名，' : str;
                    this.users.idcard == '' ? str += '身份证号，' : str;
                    this.users.company == '' ? str += '单位名称，' : str;
                    this.certificateArr.length > 1 ? str += '本次证明中包含【仅适用于' + cer_years[0].substr(0, 4) +
                        '】的课程，其余课程无法设置为其他年度，' : str;
                    str = str.substr(0, str.length - 1);
                    this.infoRemind = str;
                }
            }
            // 将“确认打印”的按钮设置为禁止点击
            document.querySelector('#confirm-print-btn').setAttribute('disabled', 'disabled');
            // 刷新当前页
            // this.$router.go(0)
        },
        //获取已经生成的证书
        alreadyCreated: function() {
            this.okCertificate = [];
            this.$post('cers/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 999,
            }).then(res => {
                // console.log(res)
                this.okCertificate = res.data.result.data;
            })

        },
        
        // 生成课程证书
        getProductCer(product_id, product_name, period, cer_year, pay_date, end_date, purchased_id){
            
            
            
        },

        //获取已经生成的课程证书
        alreadyCreatedType2() {
            this.okCertificate = [];
            this.$post('cers/find', {
                token: this.$store.state.id,
                offset: 0,
                length: 999,
                cer_type: 2
            }).then(res => {
                // console.log(res)
                this.okCertificate = res.data.result.data;
            })
        },



        // 标记打开页面
        cosl1(res) {
            this.currentPage = 1
            this.cosl = res
            this.init()
        },
        // 证书
        cosl2(res) {
            this.cosl0 = res
            this.init()
        },
        init() {
            this.checked1 = false
            this.checked2 = false
            this.checked3 = false
            this.checked4 = false
            this.checked5 = false
            this.value = '全部'
            this.screen1()
        },
        // 获取筛选时间数组
        getdate() {
            let date = new Date;
            let arr = {}
            let year = date.getFullYear();
            for (let i = year; i >= 2018; i--) {
                arr = {
                    value: i,
                    label: i
                }
                this.options.push(arr)
            }
        },
        // 筛选
        screen1() {
            let data
            let product_attr
            let products_cer_year
            let products_is_auth
            let url = 'orders/search_pay_all'
            if (this.checked1) {
                product_attr = '专业课'
                this.checked2 = false
            } else if (this.checked2) {
                product_attr = '选修课'
                this.checked1 = false
            } else {
                product_attr = ''
            }
            if (this.checked3) {
                products_is_auth = 1 //认定
                this.checked4 = false
            } else if (this.checked4) {
                products_is_auth = 0 //非认定
                this.checked3 = false
            } else {
                products_is_auth = ''
            }
            if (this.value == '全部') {
                products_cer_year = ''
            } else {
                products_cer_year = this.value
            }
            data = {
                token: this.$store.state.id,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize
            }
            if (this.cosl == 1) { //获取全部课程
                this.get(url, data)
            } else if (this.cosl == 2) { //获取在读课程
                url = 'orders/search_pay_all'
                // data.category_progress_elt = 0.99999
                // data.category_progress_elt = 1
                // data.score_elt = 60
                data.is_read = '是'
                this.get(url, data)
            } else if (this.cosl == 3) { //获取已完成课程
                data.category_progress_egt = 1
                data.score_egt = 60
                this.get(url, data)
            } else if (this.cosl == 4) { //获取证书课程
                // if (this.cosl0 == 1) { //未完成证书
                // 	url = 'orders/search_pay_all'
                // 	// data.category_progress_elt = 0.99999
                // 	// data.category_progress_elt = 1
                //                 // data.score_elt = 60
                //                 data.is_read = '是'
                // 	this.get(url, data)
                // } else if (this.cosl0 == 2) { //已完成证书
                // 	data.category_progress_egt = 1
                // 	data.score_egt = 60
                // 	data.is_first = 0
                // 	this.get(url, data)
                // } else if (this.cosl0 == 3) { //已生成证书
                // 	this.isShowPagination = false
                // 	this.alreadyCreated();
                // }
                this.isShowPagination = false
                this.alreadyCreated();
            } else if (this.cosl == 5) {
                url = 'learn_record/search'
                data.learn_status = '已完成'
                this.get(url, data)
            } else if (this.cosl == 6) {
                url = 'orders/search_my_order'
                this.get(url, data)
            } else if (this.cosl == 7) { // 证书
                url = 'orders/search_my_order'
                
                data.new_year = 1
                data.is_first = 2
                data.progress_status = 1
                this.get(url, data)

            }
        },
        screen2() {
            if (this.checked2) {
                this.checked1 = false;
            }
            if (this.checked4) {
                this.checked3 = false;
            }
            this.screen1();
        },
        //获取数据
        get(url, data) {
            console.log(data)
            //一点击获取数据就进入加载中
            // this.loading=true;
            // v-loading="false"
            // let me = this;
            // v-loading="loading"
            this.loading = true
            this.$post(url, data).then(res => {
                this.total = res.data.result.total
                if (this.cosl == 1) {
                    this.isShowPagination = true
                    this.classList = res.data.result.result;
                    this.courseConfig(res.data.result.result);
                } else if (this.cosl == 2) {
                    this.isShowPagination = true
                    this.inschoolclass = res.data.result.result;
                    this.courseConfig(res.data.result.result);
                } else if (this.cosl == 3) {
                    this.isShowPagination = true
                    this.accomplishclass = res.data.result.result;
                } else if (this.cosl == 7) {
                    this.isShowPagination = true
                    this.accomplishcredential = res.data.result.data;
                    console.log('accomplishcredential', this.accomplishcredential)
                } else if (this.cosl == 5) {
                    this.oldPackage = res.data.result.data
                } else if (this.cosl == 6) {
                    this.purchasedList = res.data.result.data
                }
                this.loading = false;
            })
        },
        //验证时店主后跳转到店铺管理
        toStoreManage() {
            if (String(this.$store.state.shopId) != 'undefined' && String(this.$store.state.shopId) != 'null' && String(
                    this.$store
                    .state.shopId) != '') {
                let address = this.$router.resolve({
                    path: '/coursestoremanagement'
                });
                //新页面打开店铺管理
                window.open(address.href, '_blank');
            }
        },

        // 每页的显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.screen1()
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.screen1()
        },

        // 跳转到课后习题页面
        toExam(category_order_id, resource_id, category_id, category_name) {
            this.$router.push({
                path: './classexam',
                query: {
                    id: resource_id,
                    categoryOrderId: category_order_id,
                    categoryId: category_id,
                    categoryName: category_name,
                }
            })
        },

        // 将支付完成的订单状态修改为2
        editOrdersStatus() {
            this.$post('orders/query_pay', {
                token: this.$store.state.id
            }).then(() => {
                this.screen1() //获取全部课程数据
            });
        },
        // ----------------------------------------------------------------------
        // 检查课程
        courseConfig(result) {
            let res = result
            //遍历计算进度
            res.map((item, index) => {
                let category_progress = 0
                let allProgress = 0
                item.purchased.map((item1, index1) => {
                    allProgress += item1.progress
                })
                // console.log(item)
                category_progress = allProgress / item.purchased.length
                // 课程包进度比实际课程包进度小的就发请求去纠正
                // console.log('item.category_progress',item.category_progress)
                // console.log('category_progress.toFixed(4)',category_progress.toFixed(4))
                if (item.category_progress != 1 && category_progress.toFixed(4) == 1) {
                    this.$post('category_order/update', {
                        id: item.category_order_id,
                        category_progress: 1
                    }).then(res => {
                        this.screen1() //获取全部课程数据
                    })
                }
            })
        },
        // ----------------------------------------------------------------------
    },
    created: function() {
        this.alreadyCreated(); //获取已生成证书
        this.getdate(); //获取筛选时间数组
        this.getusers(); //获取个人信息

        this.editOrdersStatus();
    },
    mounted: function() {
        document.title = '个人中心';
        UIkit.util.on('#certificate-switch', 'show', function() {});
    }
}